






























































































































































import { liveTotalApi, liveTotalListApi } from "@/api/live";
import {
  dateFormat,
  getCurrentWeek,
  getCurrentMonth,
} from "@/utils/timeFormat";
import studentDialog from "./studentDialog.vue";
import { getSelectClassList } from "@/api/globalSearch";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { Vue, Component } from "vue-property-decorator";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    studentDialog,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    teacher_id: "",
    teacher_list: [],
  };
  classList: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  // pickerOptions: any = {
  //   shortcuts: [
  //     {
  //       text: "今天",
  //       onClick(picker: any) {
  //         const today = new Date();
  //         picker.$emit("pick", [today, today]);
  //       },
  //     },
  //     {
  //       text: "最近7天",
  //       onClick(picker: any) {
  //         const today = new Date().getTime();
  //         const start = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today - 3 * 24 * 60 * 60 * 1000)
  //         );
  //         const end = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today + 3 * 24 * 60 * 60 * 1000)
  //         );
  //         picker.$emit("pick", [start, end]);
  //       },
  //     },
  //     {
  //       text: "最近30天",
  //       onClick(picker: any) {
  //         const today = new Date().getTime();
  //         const start = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today - 15 * 24 * 60 * 60 * 1000)
  //         );
  //         const end = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today + 15 * 24 * 60 * 60 * 1000)
  //         );
  //         picker.$emit("pick", [start, end]);
  //       },
  //     },
  //     {
  //       text: "本周",
  //       onClick(picker: any) {
  //         const arr = getCurrentWeek();
  //         picker.$emit("pick", arr);
  //       },
  //     },
  //     {
  //       text: "本月",
  //       onClick(picker: any) {
  //         const arr = getCurrentMonth();
  //         picker.$emit("pick", arr);
  //       },
  //     },
  //   ],
  // };
  totalData: any = {};
  created() {
    const today = new Date().getTime();
    const startM = dateFormat(
      "YYYY-mm-dd",
      new Date(today - 15 * 24 * 60 * 60 * 1000)
    );
    const endM = dateFormat(
      "YYYY-mm-dd",
      new Date(today + 15 * 24 * 60 * 60 * 1000)
    );
    this.searchInfo.lesson_date = [startM, endM];
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    liveTotalApi().then((res: any) => {
      this.totalData = res.data;
    });
    this.handleSearchClass("");
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.class_id) {
      option.class_id = this.searchInfo.class_id;
    }
    if (this.searchInfo.teacher_id) {
      option.teacher_id = this.searchInfo.teacher_id;
    }
    if (this.searchInfo.lesson_date) {
      option.start_date = this.searchInfo.lesson_date[0];
      option.end_date = this.searchInfo.lesson_date[1];
    }
    liveTotalListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.weekZh = ["日", "一", "二", "三", "四", "五", "六"][
            item.week_day
          ];
          item.live_date = dateFormat(
            "YYYY-mm-dd",
            new Date(item.live_start_time * 1000)
          ).slice(0, 10);
          item.live_start_time = dateFormat(
            "HH:MM",
            new Date(item.live_start_time * 1000)
          );
          item.live_end_time = dateFormat(
            "HH:MM",
            new Date(item.live_end_time * 1000)
          );
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = params.page;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSearchClass(v: any) {
    getSelectClassList({
      page: 1,
      page_size: 50,
      name: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.classList = res.data.list;
      }
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
